// @owners { team: patients-team }
import { Card } from '@alto/design-system';
import React from 'react';
import { getOrderDate } from '~shared/features/checkout/selectors/getOrder';
import { useSelectorShared } from '~shared/store';
import { useCheckoutAddressInfoKeys } from '../../hooks/useCheckoutAddressInfoKeys';
import { WindowSelector } from '../delivery-date-card/WindowSelector';

export const SelectTimeCard = () => {
  const date = useSelectorShared(getOrderDate);
  const { deliveryWindowRequired } = useCheckoutAddressInfoKeys();
  const showDeliveryWindow = !!date && deliveryWindowRequired;

  if (!showDeliveryWindow) {
    return null;
  }

  return (
    <Card
      title="Select time"
      overflow="hidden"
    >
      <WindowSelector />
    </Card>
  );
};
